import React, {useState} from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
// import { blue, red } from '@mui/material/colors';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AvatarPic from "../../assets/images/avtarPic.png";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import FavoriteIcon from '@mui/icons-material/Favorite';
import ReplyIcon from '@mui/icons-material/Reply';
// import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import ForumIcon from '@mui/icons-material/Forum';
import SendIcon from '@mui/icons-material/Send';

function MobileDiscussionDetails() {
    const navigate = useNavigate();
  const [commetViewShow, setCommetViewShow] = useState(false);
  const [replyViewShow, setReplyViewShow] = useState(false);
  return (
    <div className='MainView'> 
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileDiscussionForum")}
        />
        <h1>Discussion Details</h1>
    </div>
    <div className='topSpace'></div>
    <div className="famDetailsListInrMob">
        <p className='DiscussionDetailsTitle'>Discussion Title Discussion Title</p>
    </div>
    <div className='DiscussionDetailsView'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
          <div>
          <p className='ticketTimedeteTxt'>Time & Date</p>
          <p className='pollTimeTxt'>20/07/2024 10:30 Am</p>
          </div>
        </div>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Description Description Description Description</p>
        </div>
        <div className='dividerCommon' />
        <div className='forumIconView'>
            <div className='iconWithCount'>
                <FavoriteBorderIcon sx={{fontSize:22}}/>
                <p className='formCountTxt'>5</p>
            </div>
            <div className='iconWithCount'>
                <ReplyIcon sx={{fontSize:25, color:'#0047cb'}}/>
                <p className='formCountTxt'>5</p>
            </div>
            <div className='iconWithCount' onClick={() => setCommetViewShow(!commetViewShow)} >
                <ForumIcon sx={{fontSize:22, color:'#0047cb'}}/>
                <p className='formCountTxt'>5</p>
            </div>
        </div>
        {commetViewShow?<div className='chatViewFlexEnd margineTop10'>
        <div className='ChatView2'>
        <div className="famDetailsListTo textAlignEnd">
          <div className="alignfamDetailsListToPro ">
            <div className="detailsDiMob textAlignEnd">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Comment Comment Commet
            </p>
        </div>
        </div>:null}
    </div>
      <div className='ReplyBoxView'>
        <div className="alignfamDetailsListToPro">
          <div className="ImageViewRound">
            <img src={AvatarPic} alt='altimg'/>
          </div>
          <div className="detailsDiMob">
            <h1>User Name</h1>
            <div className="mobWithIco">
              <p>20/07/2024 10:30 Am</p>
            </div>
          </div>
        </div>
        <div className='pollsTitlDescView margineTop10'>
          <p className='pollsDescripTxt'>Comment Comment Reply Reply</p>
        </div>
        <div className='dividerCommon' />
        <div className='forumIconView'>
            <div className='iconWithCount' onClick={() => setReplyViewShow(!replyViewShow)}>
                <ForumIcon sx={{fontSize:22, color:'#0047cb'}}/>
                <p className='formCountTxt'>5</p>
            </div>
        </div>
        {replyViewShow ? <div className='chatViewFlexEnd margineTop10'>
        <div className='ChatView2'>
        <div className="famDetailsListTo textAlignEnd">
          <div className="alignfamDetailsListToPro ">
            <div className="detailsDiMob textAlignEnd">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
          </div>
         </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Reply Reply Reply
            </p>
        </div>
        </div>: null}
      </div>
      <div className='chatInputBoxView'>
        <input type='text' placeholder='Type Message Here' className='chatInputBox'/>
        <SendIcon sx={{fontSize:35, color:'#005aff'}} />
      </div>
    </div>
  )
}

export default MobileDiscussionDetails